export default "__VITE_ASSET__DSdp6W8d__"